import { render, staticRenderFns } from "./LocalGuide.vue?vue&type=template&id=313844e2&scoped=true"
import script from "./LocalGuide.vue?vue&type=script&lang=js"
export * from "./LocalGuide.vue?vue&type=script&lang=js"
import style0 from "./LocalGuide.vue?vue&type=style&index=0&id=313844e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.94.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313844e2",
  null
  
)

export default component.exports